import React from "react";
import ChatbotV2Dashboard from "./components/ChatbotV2Dashboard";
import { ChatV2Provider } from "./context/ChatV2Context";
// Import CSS if needed
// import "./chatbot-v2.css"

const ChatBotV2 = () => {
  return (
    <div className="w-full h-full overflow-hidden">
      <ChatV2Provider>
        <ChatbotV2Dashboard />
      </ChatV2Provider>
    </div>
  );
};

export default ChatBotV2;
